(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-recorder-assets"] && !Shopify.designMode) return;
  try {
    // Load shared dependencies once and handle subsequent editor module updates - Plaud Tayler - 2026-10-15 18:22 - Begin
let recorderDependencies;

function loadRecorderScript(source) {
  return new Promise((resolve, reject) => {
    const absoluteSource = new URL(source, document.baseURI).href;
    let script = Array.from(document.scripts).find((node) => node.src === absoluteSource);
    const existing = Boolean(script);
    if (!script) {
      script = document.createElement('script');
      script.src = absoluteSource;
      script.dataset.recorderManaged = 'true';
    }
    function cleanup() {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    }
    function onLoad() {
      cleanup();
      resolve();
    }
    function onError() {
      cleanup();
      if (script.dataset.recorderManaged === 'true') script.remove();
      reject(new Error('Recorder dependency failed to load'));
    }
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    if (!existing) document.head.appendChild(script);
  });
}

function loadRecorderDependencies() {
  const config = document.querySelector('[data-recorder-dependencies]');
  const styles = Array.from(document.querySelectorAll('link[data-recorder-style]'));
  if (!config) return;
  // Keep the single stylesheet when the section that first supplied it is removed.
  if (styles.length) {
    if (!document.head.contains(styles[0])) document.head.appendChild(styles[0]);
    styles.slice(1).forEach((style) => style.remove());
  }
  if (recorderDependencies) return;
  recorderDependencies = Promise.resolve()
    .then(() => window.wwTabs ? undefined : loadRecorderScript(config.dataset.tabsUrl))
    .then(() => window.aiRecorderInitialized ? undefined : loadRecorderScript(config.dataset.controllerUrl))
    .catch(() => {
      config.dataset.recorderLoadError = 'true';
      recorderDependencies = null;
    });
}

// Shopify's native snippet bundle owns this one page-lifetime editor listener.
document.addEventListener('shopify:section:load', loadRecorderDependencies);
loadRecorderDependencies();
// Load shared dependencies once and handle subsequent editor module updates - Plaud Tayler - 2026-10-15 18:22 - End
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plaud-desktop-accordion"] && !Shopify.designMode) return;
  try {
    // Keep dynamic editor instances independent of the page template - Plaud Tayler - 2026-10-13 16:51 - Begin
class PlaudDesktopAccordion extends HTMLElement {
  constructor() {
    super();
    this.onToggle = this.onToggle.bind(this);
  }

  connectedCallback() {
    this.dataset.pdReady = 'true';
    // Prefer the latest selection and stop finite motion when the instance becomes inactive - Plaud Tayler - 2026-10-13 18:24 - Begin
    this.revision = (this.revision || 0) + 1;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.cancelMotion = () => { this.animation?.cancel(); this.animation = null; };
    this.onPreference = () => this.cancelMotion();
    this.onVisibility = () => { if (document.hidden) this.cancelMotion(); };
    this.motion.addEventListener('change', this.onPreference);
    document.addEventListener('visibilitychange', this.onVisibility);
    if (window.IntersectionObserver) {
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        if (!this.visible) this.cancelMotion();
      });
      this.observer.observe(this);
    }
    // Prefer the latest selection and stop finite motion when the instance becomes inactive - Plaud Tayler - 2026-10-13 18:24 - End
    this.addEventListener('toggle', this.onToggle, true);
    // Reveal a selected editor block through the existing state controller - Plaud Tayler - 2026-10-19 11:15 - Begin
    this.onBlockSelect = event => {
      const card = event.target.closest('.pd-accordion-card');
      const detail = card?.querySelector('details');
      if (!detail || !this.contains(card) || this.narrow?.matches) return;
      detail.open = true;
    };
    this.addEventListener('shopify:block:select', this.onBlockSelect);
    // Reveal a selected editor block through the existing state controller - Plaud Tayler - 2026-10-19 11:15 - End
    // Reparent existing scenes at the exact layout boundary rather than duplicate media or copy - Plaud Tayler - 2026-10-14 18:53 - Begin
    this.narrow = matchMedia('(max-width: 768px)');
    this.syncLayout = () => {
      ++this.revision;
      this.cancelMotion();
      const panes = [...this.querySelectorAll('[data-pd-state-pane]')];
      const details = [...this.querySelectorAll('details')];
      const active = this.dataset.pdState === '0' ? '1' : this.dataset.pdState;
      panes.forEach(pane => {
        const card = this.querySelector(`[data-pd-card="${pane.dataset.pdStatePane}"]`);
        (this.narrow.matches ? card : this.querySelector('[data-pd-display]')).prepend(pane);
        pane.hidden = !this.narrow.matches && pane.dataset.pdStatePane !== active;
      });
      details.forEach(detail => {
        detail.open = this.narrow.matches || detail.dataset.pdIndex === active;
        const summary = detail.querySelector('summary');
        if (this.narrow.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
    };
    this.preventNarrowToggle = event => {
      if (this.narrow.matches && event.target.closest('summary')) event.preventDefault();
    };
    this.narrow.addEventListener('change', this.syncLayout);
    this.addEventListener('click', this.preventNarrowToggle);
    this.syncLayout();
    const opened = this.querySelector('details[open]');
    if (opened && !this.narrow.matches) this.selectScene(opened);
    // Reparent existing scenes at the exact layout boundary rather than duplicate media or copy - Plaud Tayler - 2026-10-14 18:53 - End
  }

  disconnectedCallback() {
    ++this.revision;
    this.narrow?.removeEventListener('change', this.syncLayout);
    this.removeEventListener('click', this.preventNarrowToggle);
    this.cancelMotion?.();
    this.observer?.disconnect();
    this.motion?.removeEventListener('change', this.onPreference);
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.removeEventListener('toggle', this.onToggle, true);
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
    delete this.dataset.pdReady;
  }

  onToggle(event) {
    if (this.narrow?.matches) return;
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement)) return;
    if (!opened.open) {
      if (!this.querySelector('details[open]')) this.dataset.pdState = '0';
      return;
    }
    this.querySelectorAll('details[open]').forEach((details) => {
      if (details !== opened) details.open = false;
    });
    this.selectScene(opened);
  }

  // Keep the previous artwork readable until the requested image can be painted - Plaud Tayler - 2026-10-13 18:24 - Begin
  async selectScene(opened) {
    this.cancelMotion();
    const state = opened.dataset.pdIndex || '1';
    this.dataset.pdState = state;
    const revision = ++this.revision;
    const panes = [...this.querySelectorAll('[data-pd-state-pane]')];
    const incoming = panes.find(pane => pane.dataset.pdStatePane === state);
    if (!incoming || !incoming.hidden) return;
    const images = [...incoming.querySelectorAll('img')];
    images.forEach(image => { image.loading = 'eager'; });
    await Promise.all(images.map(image => image.decode ? image.decode().catch(() => {}) : Promise.resolve()));
    if (!this.isConnected || revision !== this.revision) return;
    this.cancelMotion();
    panes.forEach(pane => { pane.hidden = pane !== incoming; });
    if (!this.motion.matches && this.visible && !document.hidden && incoming.animate) {
      const style = getComputedStyle(this);
      this.animation = incoming.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: parseFloat(style.getPropertyValue('--pd-motion-media')) || 300,
        easing: style.getPropertyValue('--pd-motion-ease').trim() || 'ease-out'
      });
    }
  }
  // Keep the previous artwork readable until the requested image can be painted - Plaud Tayler - 2026-10-13 18:24 - End
}

if (!customElements.get('plaud-desktop-accordion')) {
  customElements.define('plaud-desktop-accordion', PlaudDesktopAccordion);
}
// Keep dynamic editor instances independent of the page template - Plaud Tayler - 2026-10-13 16:51 - End
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plaud-desktop-carousel"] && !Shopify.designMode) return;
  try {
    // Extend the existing native rail; keep loading and registration shared across editor instances - Plaud Tayler - 2026-10-14 18:53 - Begin
if (!customElements.get('plaud-desktop-carousel')) {
  const instance = document.querySelector('plaud-desktop-carousel[data-base-script]');
  if (!customElements.get('sa-why-see-action-carousel') && instance && !window.pdCarouselBase) {
    window.pdCarouselBase = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = instance.dataset.baseScript;
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    });
  }
  Promise.resolve(window.pdCarouselBase).then(() => {
    const Base = customElements.get('sa-why-see-action-carousel');
    if (!Base || customElements.get('plaud-desktop-carousel')) return;
    class PlaudDesktopCarousel extends Base {
      connectedCallback() {
        super.connectedCallback();
        if (!this.track) return;
        this.controls = this.querySelector('.pd-rail-controls');
        this.resize = new ResizeObserver(() => this.updateProgress());
        this.resize.observe(this.track);
        this.updateProgress();
        this.stopScroll = () => this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'auto' });
        this.visibility = () => { if (document.hidden) this.stopScroll(); };
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.preference.addEventListener('change', this.stopScroll);
        document.addEventListener('visibilitychange', this.visibility);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) this.stopScroll();
        });
        this.observer.observe(this);
        // Keep selected editor cards visible in the existing native rail - Plaud Tayler - 2026-10-19 11:15 - Begin
        this.onBlockSelect = event => {
          const card = event.target.closest('.sa-why-see-action__card');
          if (!card || !this.track.contains(card) || this.track.scrollWidth <= this.track.clientWidth + 2) return;
          const offset = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
          this.track.scrollBy({ left: offset, behavior: 'auto' });
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        // Keep selected editor cards visible in the existing native rail - Plaud Tayler - 2026-10-19 11:15 - End
      }
      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resize?.disconnect();
        this.observer?.disconnect();
        this.preference?.removeEventListener('change', this.stopScroll);
        document.removeEventListener('visibilitychange', this.visibility);
        super.disconnectedCallback();
      }
      updateProgress() {
        super.updateProgress();
        if (this.controls && this.track) {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum <= 2;
          if (this.prevBtn) this.prevBtn.disabled = position <= 1;
          if (this.nextBtn) this.nextBtn.disabled = position >= maximum - 1;
        }
      }
      move(direction) {
        if (!this.track) return;
        const bounds = this.getBoundingClientRect();
        const animate = !document.hidden && bounds.bottom > 0 && bounds.top < innerHeight && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inlineDirection = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * inlineDirection * this.getCardWidth(), behavior: animate ? 'smooth' : 'auto' });
      }
      handlePrev() { this.move(-1); }
      handleNext() { this.move(1); }
    }
    customElements.define('plaud-desktop-carousel', PlaudDesktopCarousel);
  }).catch(() => {});
}
// Extend the existing native rail; keep loading and registration shared across editor instances - Plaud Tayler - 2026-10-14 18:53 - End
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plaud-desktop-download"] && !Shopify.designMode) return;
  try {
    /* Reuse v1 popup semantics while owning this section's listeners and transient modal - Plaud Tayler - 2026-10-23 12:26 - Begin */
function registerPlaudDesktopDownload() {
  if (customElements.get('plaud-desktop-download')) return true;
  if (typeof PopupBase === 'undefined' || typeof tingle === 'undefined') return false;
  class PlaudDesktopDownload extends PopupBase {
    connectedCallback() {
      this.trigger = this.querySelector('button');
      this.content = this.querySelector('[data-download-content]');
      if (!this.trigger || !this.content) return;
      this.querySelector('.pd-download-fallback')?.remove();
      this.onOpenClick = () => this.openDownload();
      this.onVisibility = () => {
        if (document.hidden && this.modal?.modal) this.modal.modal.setAttribute('data-static-motion', '');
      };
      this.trigger.addEventListener('click', this.onOpenClick);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onBlockSelect = () => this.openDownload();
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.trigger.hidden = false;
      /* Match v1's deferred hash activation without retaining callbacks after section removal - Plaud Tayler - 2026-10-26 11:31 - Begin */
      this.onHashChange = () => {
        window.clearTimeout(this.hashTimer);
        this.hashTimer = null;
        if (window.location.hash.toLowerCase() !== '#download') return;
        this.hashTimer = window.setTimeout(() => {
          this.hashTimer = null;
          if (this.isConnected && window.location.hash.toLowerCase() === '#download') this.openDownload();
        }, 500);
      };
      window.addEventListener('hashchange', this.onHashChange);
      this.onHashChange();
      /* Match v1's deferred hash activation without retaining callbacks after section removal - Plaud Tayler - 2026-10-26 11:31 - End */
    }

    openDownload() {
      if (this.modal || this.closingTimer || document.getElementById(this.dataset.dialogId) || document.querySelector('.tingle-modal--visible:not(.remove-loading)')) return;
      const content = this.content.content.firstElementChild.cloneNode(true);
      this.initPopup(content, null, 'pd-download-modal', (box) => {
        box.id = this.dataset.dialogId;
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-labelledby', this.dataset.titleId);
        this.trigger.setAttribute('aria-expanded', 'true');
        this.trigger.setAttribute('aria-controls', this.dataset.dialogId);
        const icon = this.querySelector('[data-download-close]')?.content.cloneNode(true);
        const close = this.modal.modalCloseBtn;
        if (close) {
          close.setAttribute('aria-label', this.dataset.closeLabel);
          if (icon?.firstElementChild) close.querySelector('.tingle-modal__closeIcon').replaceChildren(icon);
        }
        /* Keep independent overlay portals interactive so their clicks cannot fall through to this backdrop - Plaud Tayler - 2026-10-26 11:44 - Begin */
        this.inerted = Array.from(document.body.children).filter((node) => node !== this.modal.modal && !node.inert && !node.matches('script, style, dialog, .tingle-modal, [role="dialog"], #cmpwrapper, #shopify-pc__banner, #shopify-pc__prefs'));
        /* Keep independent overlay portals interactive so their clicks cannot fall through to this backdrop - Plaud Tayler - 2026-10-26 11:44 - End */
        this.inerted.forEach((node) => { node.inert = true; });
        /* Scope Tingle's document-level Escape behavior to this dialog without changing the shared engine - Plaud Tayler - 2026-10-26 11:44 - Begin */
        this.modal.opts.closeMethods = this.modal.opts.closeMethods.filter((method) => method !== 'escape');
        this.dialogBox = box;
        this.onDialogKeyDown = (event) => {
          if (event.key !== 'Escape' || event.defaultPrevented) return;
          event.preventDefault();
          event.stopPropagation();
          this.modal?.close();
        };
        box.addEventListener('keydown', this.onDialogKeyDown);
        /* Scope Tingle's document-level Escape behavior to this dialog without changing the shared engine - Plaud Tayler - 2026-10-26 11:44 - End */
        this.onVisibility();
        box.setAttribute('tabindex', '-1');
        box.focus({ preventScroll: true });
        close?.focus({ preventScroll: true });
      });
      this.removeAttribute('aria-expanded');
    }

    onCloseEvent() {
      this.dialogBox?.removeEventListener('keydown', this.onDialogKeyDown);
      this.dialogBox = null;
      (this.inerted || []).forEach((node) => { node.inert = false; });
      this.inerted = [];
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.trigger?.removeAttribute('aria-controls');
      this.removeAttribute('aria-expanded');
      // PopupBase returns focus before this hook; retry after restoring background interactivity.
      this.trigger?.focus({ preventScroll: true });
      this.modal = null;
      this.closingTimer = window.setTimeout(() => { this.closingTimer = null; }, 260);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onOpenClick);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('hashchange', this.onHashChange);
      window.clearTimeout(this.hashTimer);
      this.hashTimer = null;
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.modal?.modal) this.modal.close();
      window.clearTimeout(this.closingTimer);
      this.closingTimer = null;
      this._focusTrapCleanup?.();
      this._focusTrapCleanup = null;
    }
  }
  customElements.define('plaud-desktop-download', PlaudDesktopDownload);
  return true;
}
if (!registerPlaudDesktopDownload()) {
  // Native snippet bundles precede the deferred v1 popup dependencies in the theme document.
  const dependencies = Array.from(document.scripts).filter((script) => /\/(global|tingle\.min)\.js(?:\?|$)/.test(script.src));
  const register = () => {
    if (!registerPlaudDesktopDownload()) return;
    dependencies.forEach((script) => script.removeEventListener('load', register));
    document.removeEventListener('DOMContentLoaded', register);
    window.removeEventListener('load', register);
  };
  dependencies.forEach((script) => script.addEventListener('load', register));
  document.addEventListener('DOMContentLoaded', register, { once: true });
  window.addEventListener('load', register, { once: true });
}
/* Reuse v1 popup semantics while owning this section's listeners and transient modal - Plaud Tayler - 2026-10-23 12:26 - End */
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plaud-desktop-hero-scene"] && !Shopify.designMode) return;
  try {
    // Keep one visible, pausable timeline for the meeting-to-outcome demonstration - Plaud Tayler - 2026-10-15 11:46 - Begin
class PlaudDesktopHeroScene extends HTMLElement {
  connectedCallback() {
    this.animations = new Set();
    this.epoch = (this.epoch || 0) + 1;
    this.inView = false;
    this.userPaused = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.button = this.querySelector('.pd-hero-scene__toggle');
    this.onPreference = () => this.motion.matches ? this.finish() : this.sync();
    this.onVisibility = () => this.sync();
    this.onToggle = () => { this.userPaused = !this.userPaused; this.sync(); };
    this.onResize = () => { if (this.hasAttribute('data-enhanced')) this.compose(); };
    this.motion.addEventListener('change', this.onPreference);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.button?.addEventListener('click', this.onToggle);
    if (!this.hasAttribute('data-enabled') || !window.IntersectionObserver || !window.ResizeObserver || !Element.prototype.animate || !CSS.supports('width', '1cqw')) return;
    this.observer = new IntersectionObserver(entries => { this.inView = entries.some(entry => entry.isIntersecting); this.sync(); }, { threshold: 0.15 });
    this.observer.observe(this);
    this.resize = new ResizeObserver(this.onResize);
    this.resize.observe(this);
  }

  sync() {
    if (!this.hasAttribute('data-enabled') || this.motion.matches) return;
    const visible = this.inView && !document.hidden;
    if (!this.hasAttribute('data-enhanced')) {
      if (visible && this.dataset.state === 'static') this.start();
      return;
    }
    const playing = visible && !this.userPaused;
    this.animations.forEach(animation => {
      if (playing && animation.playState === 'paused') animation.play();
      else if (!playing && animation.playState === 'running') animation.pause();
    });
    this.dataset.state = playing ? 'playing' : 'paused';
    if (this.button) {
      this.button.setAttribute('aria-pressed', String(this.userPaused));
      this.button.setAttribute('aria-label', this.userPaused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel);
      this.button.querySelector('[data-pause-icon]').hidden = this.userPaused;
      this.button.querySelector('[data-play-icon]').hidden = !this.userPaused;
    }
    cancelAnimationFrame(this.frame);
    if (playing) this.tick();
  }

  async start() {
    const template = this.querySelector('template');
    if (!template) return;
    const epoch = this.epoch;
    this.dataset.state = 'loading';
    try {
      const poster = this.querySelector('.pd-hero-scene__poster img');
      if (!poster) throw new Error('Missing poster');
      await poster.decode();
      if (epoch !== this.epoch || !this.isConnected) return;
      this.appendChild(template.content.cloneNode(true));
      const images = [...this.querySelectorAll('.pd-hero-scene__layers img')];
      await Promise.race([
        Promise.all(images.map(image => image.decode())),
        new Promise((_, reject) => { this.loadTimer = setTimeout(() => reject(new Error('Hero media timeout')), 8000); })
      ]);
      clearTimeout(this.loadTimer);
      if (epoch !== this.epoch || !this.isConnected) return;
      if (images.length !== 7 || this.motion.matches) { this.finish(); return; }
      this.typed = this.querySelector('[data-story-typed]');
      this.copy = Array.from(this.typed.dataset.copy);
      this.characterCount = -1;
      this.setAttribute('data-enhanced', '');
      if (this.button) this.button.hidden = false;
      this.compose();
    } catch (_) {
      if (epoch === this.epoch) this.finish();
    }
  }

  compose() {
    const time = this.clock?.currentTime || 0;
    this.animations.forEach(animation => animation.cancel());
    this.animations.clear();
    const compact = matchMedia('(max-width: 768px)').matches;
    const width = this.clientWidth;
    const height = this.clientHeight;
    const scale = compact ? 2.4 : 1.65;
    const focus = `translate(${width * ((compact ? 0.545 : 0.56) - 0.87034)}px, ${height * (0.48 - 0.8127)}px) scale(${scale})`;
    const easing = 'cubic-bezier(.62,.02,.18,1)';
    const add = (target, frames) => {
      if (!target) return;
      const animation = target.animate(frames.map(frame => ({ easing, ...frame })), { duration: 16000, iterations: Infinity, fill: 'both' });
      animation.pause();
      animation.currentTime = time;
      this.animations.add(animation);
      return animation;
    };
    const q = selector => this.querySelector(selector);
    const layer = name => q(`[data-layer="${name}"]`);
    this.clock = add(q('.pd-hero-scene__layers'), [{ opacity: 1 }, { opacity: 1 }]);
    for (const name of ['application', 'meeting', 'participant', 'apps']) {
      add(layer(name), [
        { offset: 0, opacity: 1, filter: 'blur(0px)' }, { offset: 0.16, opacity: 1, filter: 'blur(0px)' },
        { offset: 0.23, opacity: 0.06, filter: 'blur(5px)' }, { offset: 0.86, opacity: 0.06, filter: 'blur(5px)' },
        { offset: 0.96, opacity: 1, filter: 'blur(0px)' }, { offset: 1, opacity: 1, filter: 'blur(0px)' }
      ]);
    }
    add(layer('capture'), [
      { offset: 0, transform: 'none', opacity: 1 }, { offset: 0.16, transform: 'none', opacity: 1 },
      { offset: 0.24, transform: focus, opacity: 1 }, { offset: 0.43, transform: focus, opacity: 1 },
      { offset: 0.49, transform: `${focus} translateY(-8px)`, opacity: 0 }, { offset: 0.86, transform: focus, opacity: 0 },
      { offset: 0.96, transform: 'none', opacity: 1 }, { offset: 1, transform: 'none', opacity: 1 }
    ]);
    add(layer('note'), [{ offset: 0, opacity: 1 }, { offset: 0.19, opacity: 1 }, { offset: 0.23, opacity: 0 }, { offset: 0.88, opacity: 0 }, { offset: 0.96, opacity: 1 }, { offset: 1, opacity: 1 }]);
    add(q('[data-story-context]'), [{ offset: 0, opacity: 0 }, { offset: 0.23, opacity: 0 }, { offset: 0.25, opacity: 1 }, { offset: 0.44, opacity: 1 }, { offset: 0.5, opacity: 0 }, { offset: 1, opacity: 0 }]);
    add(q('[data-story-result]'), [{ offset: 0, opacity: 0, transform: 'scale(.82) translateY(18px)' }, { offset: 0.44, opacity: 0, transform: 'scale(.82) translateY(18px)' }, { offset: 0.52, opacity: 1, transform: 'none' }, { offset: 0.84, opacity: 1, transform: 'none' }, { offset: 0.92, opacity: 0, transform: 'scale(.92) translateY(-8px)' }, { offset: 1, opacity: 0, transform: 'scale(.92) translateY(-8px)' }]);
    this.querySelectorAll('[data-story-row]').forEach((row, index) => {
      const at = 0.53 + index * 0.055;
      add(row, [{ offset: 0, opacity: 0, transform: 'translateY(12px)' }, { offset: at, opacity: 0, transform: 'translateY(12px)' }, { offset: at + 0.045, opacity: 1, transform: 'none' }, { offset: 0.85, opacity: 1, transform: 'none' }, { offset: 0.92, opacity: 0, transform: 'none' }, { offset: 1, opacity: 0, transform: 'none' }]);
    });
    add(q('.pd-hero-scene__status'), [{ offset: 0, opacity: 0 }, { offset: 0.04, opacity: 1 }, { offset: 0.83, opacity: 1 }, { offset: 0.9, opacity: 0 }, { offset: 1, opacity: 0 }]);
    const wave = add(layer('wave'), [{ transform: 'scaleY(1)' }, { transform: 'scaleY(.4)' }, { transform: 'scaleY(.9)' }, { transform: 'scaleY(.6)' }, { transform: 'scaleY(1)' }]);
    wave.effect.updateTiming({ duration: 850 });
    this.sync();
  }

  tick() {
    const time = ((this.clock?.currentTime || 0) % 16000) / 16000;
    const phase = time < 0.24 ? 'capture' : time < 0.39 ? 'context' : time < 0.49 ? 'context-done' : 'result';
    if (this.dataset.phase !== phase) this.dataset.phase = phase;
    const count = Math.floor(Math.min(1, Math.max(0, (time - 0.25) / 0.14)) * this.copy.length);
    if (this.characterCount !== count) {
      this.typed.textContent = this.copy.slice(0, count).join('');
      this.characterCount = count;
    }
    this.frame = requestAnimationFrame(() => this.tick());
  }

  finish() {
    this.epoch += 1;
    clearTimeout(this.loadTimer);
    cancelAnimationFrame(this.frame);
    this.animations.forEach(animation => animation.cancel());
    this.animations.clear();
    this.removeAttribute('data-enhanced');
    this.dataset.state = 'static';
    this.querySelector('.pd-hero-scene__layers')?.remove();
    if (this.button) this.button.hidden = true;
  }

  disconnectedCallback() {
    this.finish();
    this.observer?.disconnect();
    this.resize?.disconnect();
    this.motion?.removeEventListener('change', this.onPreference);
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.button?.removeEventListener('click', this.onToggle);
  }
}
if (!customElements.get('plaud-desktop-hero-scene')) customElements.define('plaud-desktop-hero-scene', PlaudDesktopHeroScene);
// Keep one visible, pausable timeline for the meeting-to-outcome demonstration - Plaud Tayler - 2026-10-15 11:46 - End
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plaud-desktop-motion"] && !Shopify.designMode) return;
  try {
    // Animate only visible module content and release every instance-owned resource - Plaud Tayler - 2026-10-13 18:24 - Begin
class PlaudDesktopReveal extends HTMLElement {
  connectedCallback() {
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.animations = new Set();
    this.onPreference = () => this.reset();
    this.onVisibility = () => { if (document.hidden) this.finish(); };
    this.onFocus = () => this.finish();
    this.motion.addEventListener('change', this.onPreference);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.addEventListener('focusin', this.onFocus);
    this.reset();
  }

  finish() {
    this.animations.forEach(animation => animation.cancel());
    this.animations.clear();
  }

  reset() {
    this.finish();
    this.observer?.disconnect();
    if (this.motion.matches || !window.IntersectionObserver) return;
    const style = getComputedStyle(this);
    const duration = parseFloat(style.getPropertyValue('--pd-motion-reveal')) || 650;
    const easing = style.getPropertyValue('--pd-motion-ease').trim() || 'ease-out';
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          entry.target.getAnimations().forEach(animation => {
            if (this.animations.has(animation)) { animation.cancel(); this.animations.delete(animation); }
          });
          return;
        }
        if (entry.target.dataset.pdRevealed) return;
        entry.target.dataset.pdRevealed = 'true';
        if (document.hidden || entry.boundingClientRect.top < 0 || !entry.target.animate) return;
        const animation = entry.target.animate(
          [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration, easing }
        );
        this.animations.add(animation);
        animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
      });
    }, { threshold: 0.12 });
    this.querySelectorAll('.pd-section-heading, .pd-meeting-card, .pd-security__cards article, .pd-consent__panel, .pd-conversation-card, .pd-productivity__content, .pd-connected__visual')
      .forEach(target => this.observer.observe(target));
  }

  disconnectedCallback() {
    this.finish();
    this.observer?.disconnect();
    this.motion?.removeEventListener('change', this.onPreference);
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.removeEventListener('focusin', this.onFocus);
  }
}
if (!customElements.get('plaud-desktop-reveal')) customElements.define('plaud-desktop-reveal', PlaudDesktopReveal);
// Animate only visible module content and release every instance-owned resource - Plaud Tayler - 2026-10-13 18:24 - End
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plaud-desktop-ticks"] && !Shopify.designMode) return;
  try {
    // Gate the decorative waveform by viewport, document visibility and motion preference - Plaud Tayler - 2026-10-14 14:21 - Begin
class PlaudDesktopWave extends HTMLElement {
  connectedCallback() {
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.inView = false;
    // Extend only the visible band capacity and retain the source sequence phase - Plaud Tayler - 2026-10-14 14:46 - Begin
    this.lines = [...this.querySelectorAll('[data-wave-base-count]')];
    this.updateBars = () => {
      const style = getComputedStyle(this);
      const fluid = style.getPropertyValue('--pd-wave-fluid').trim() === '1';
      const sequence = style.getPropertyValue('--pd-wave-sequence').trim().split(/\s+/);
      this.lines.forEach(line => {
        const template = line.firstElementChild;
        if (!template) return;
        const base = Number(line.dataset.waveBaseCount) || line.children.length;
        const gap = parseFloat(getComputedStyle(line).columnGap) || 0;
        const width = parseFloat(getComputedStyle(template).width) || 1;
        const count = fluid ? Math.max(base, Math.floor((line.getBoundingClientRect().width + gap) / (width + gap))) : base;
        while (line.children.length > count) line.lastElementChild.remove();
        while (line.children.length < count) line.appendChild(template.cloneNode(false));
        const phase = line.dataset.waveSide === 'left' ? (sequence.length - count % sequence.length) % sequence.length : 0;
        [...line.children].forEach((bar, index) => {
          bar.style.setProperty('--pd-wave-index', String(index));
          if (fluid && sequence[0]) bar.style.setProperty('--pd-wave-color', `var(--pd-wave-${sequence[(phase + index) % sequence.length]})`);
          else bar.style.removeProperty('--pd-wave-color');
        });
      });
    };
    this.updateBars();
    if (window.ResizeObserver) {
      this.resize = new ResizeObserver(this.updateBars);
      this.lines.forEach(line => this.resize.observe(line));
    }
    // Extend only the visible band capacity and retain the source sequence phase - Plaud Tayler - 2026-10-14 14:46 - End
    this.sync = () => this.classList.toggle('is-playing', this.inView && !document.hidden && !this.motion.matches);
    this.motion.addEventListener('change', this.sync);
    document.addEventListener('visibilitychange', this.sync);
    if (window.IntersectionObserver) {
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting);
        this.sync();
      });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.resize?.disconnect();
    this.motion?.removeEventListener('change', this.sync);
    document.removeEventListener('visibilitychange', this.sync);
    this.classList.remove('is-playing');
  }
}
if (!customElements.get('plaud-desktop-wave')) customElements.define('plaud-desktop-wave', PlaudDesktopWave);
// Gate the decorative waveform by viewport, document visibility and motion preference - Plaud Tayler - 2026-10-14 14:21 - End
  } catch(e) { console.error(e); }
})();

})();
